// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-wrap-competition {
    background-color: #150924;
    color: white;
    padding: 91px 100px 49px;
}

.banner-buttons {
    align-items: center;
}

.banner-wrap-competition .banner-content {
    text-align: left;
    padding-left: 50px;
    /* max-width: 690px; */
}

.banner-wrap-competition .banner-content .title {
    color: #FFF;
    font-size: 56px;
    font-style: normal;
    font-weight: 700;
    line-height: 68px;
    text-align: left;
    font-family: "Inter", sans-serif;
}

.banner-wrap-competition .banner-content .description {
    color: #FFF;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 34px;

}

.banner-wrap-competition .banner-content .sub-description {
    color: #FFF;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    padding: 16px 0px;
}

.banner-wrap-competition .banner-buttons button {
    padding: 0.75rem 2rem;
    border: none;
    cursor: pointer;
}

.banner-wrap-competition .banner-buttons .btn-dark {
    background-color: #00D49A;
    color: #242424;
    border: none;
    padding: 18px 48px;
    text-align: center;
    font-size: 18.333px;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
}

.banner-wrap-competition .banner-buttons .btn-dark img {
    height: 24px;
}

.banner-wrap-competition .banner-buttons .btn-light {
    background-color: transparent;
    color: #06EFC5;
    border: 1px solid transparent;
    text-align: center;
    font-size: 18.333px;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
}

.banner-wrap-competition .banner-buttons .btn-light img {
    height: 24px;
}

.banner-wrap-competition .banner-right-img img {
    width: unset;
    height: unset;
}

.launching-date-wrap {
    padding: 91px 90px 77px;
    background-color: #150924;
}

.launching-date-wrap .top-button a {
    color: #150924 !important;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 33px;
    background-color: #F495D3;
    border-radius: 40px;
    text-decoration: none;
    padding: 5px 17px;
}

.launching-date-wrap .top-button a:hover {
    text-decoration: none !important;
}

.launching-date-wrap .description {
    color: #FFF;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 33px;
    padding: 32px 0px 43px;
}

.launching-date-wrap .bottom-btn a {
    color: var(--Balck, #242424);
    text-align: center;
    font-size: 18.333px;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
    background-color: #06EFC5;
    text-decoration: none;
    color: black !important;
    padding: 18px 80px;
}

.launching-date-wrap .bottom-button a:hover {
    text-decoration: none !important;
}

.launching-date-wrap a {
    text-decoration: none !important
}

.launching-date-wrap .bottom-description {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 33px;
    padding-top: 40px;
}

.launching-date-wrap .right-img img {
    height: 500px;

}


@media (max-width: 1024px) {
    .banner-wrap-competition .banner-right-img img{
        width: 100%;
    }
}

@media (max-width: 768px) {
    .banner-wrap-competition {
        padding: 30px;
    }

    .banner-wrap-competition .banner-right-img {
        display: block;
    }

    .banner-wrap-competition .banner-content {
        padding-left: 0px;
    }

    .banner-wrap-competition .banner-content .title {
        font-size: 25px;
        line-height: 39px;
    }

    .banner-wrap-competition .banner-content .sub-description {
        font-size: 20px;
        line-height: 34px;
        text-align: left;
    }

    .banner-wrap-competition .banner-content .description {
        font-size: 15px;
        font-weight: 400;
        line-height: 19px;
        text-align: left;
    }

    .banner-wrap-competition .banner-right-img img {
        width: 100%;
    }

    .banner-wrap-competition .banner-buttons {
        flex-direction: column;
        gap: 0.5rem;
        display: none !important;
    }

    .launching-date-wrap {
        padding: 50px 0px 70px;
        text-align: center;
    }

    .launching-date-wrap .top-button a {
        font-size: 15px;
        line-height: 33px;
    }

    .launching-date-wrap .description {
        font-size: 15px;
        line-height: 29px;
        padding-top: 20px;
    }

    .launching-date-wrap .bottom-description {
        padding: 50px 0px 40px;
        font-size: 15px;
        line-height: 33px;
    }

    .launching-date-wrap .right-img img {
        width: 100%;
        height: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Competition/Competition.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;;AAEjB;;;AAGA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".banner-wrap-competition {\n    background-color: #150924;\n    color: white;\n    padding: 91px 100px 49px;\n}\n\n.banner-buttons {\n    align-items: center;\n}\n\n.banner-wrap-competition .banner-content {\n    text-align: left;\n    padding-left: 50px;\n    /* max-width: 690px; */\n}\n\n.banner-wrap-competition .banner-content .title {\n    color: #FFF;\n    font-size: 56px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 68px;\n    text-align: left;\n    font-family: \"Inter\", sans-serif;\n}\n\n.banner-wrap-competition .banner-content .description {\n    color: #FFF;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 34px;\n\n}\n\n.banner-wrap-competition .banner-content .sub-description {\n    color: #FFF;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 34px;\n    padding: 16px 0px;\n}\n\n.banner-wrap-competition .banner-buttons button {\n    padding: 0.75rem 2rem;\n    border: none;\n    cursor: pointer;\n}\n\n.banner-wrap-competition .banner-buttons .btn-dark {\n    background-color: #00D49A;\n    color: #242424;\n    border: none;\n    padding: 18px 48px;\n    text-align: center;\n    font-size: 18.333px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n}\n\n.banner-wrap-competition .banner-buttons .btn-dark img {\n    height: 24px;\n}\n\n.banner-wrap-competition .banner-buttons .btn-light {\n    background-color: transparent;\n    color: #06EFC5;\n    border: 1px solid transparent;\n    text-align: center;\n    font-size: 18.333px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n}\n\n.banner-wrap-competition .banner-buttons .btn-light img {\n    height: 24px;\n}\n\n.banner-wrap-competition .banner-right-img img {\n    width: unset;\n    height: unset;\n}\n\n.launching-date-wrap {\n    padding: 91px 90px 77px;\n    background-color: #150924;\n}\n\n.launching-date-wrap .top-button a {\n    color: #150924 !important;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 33px;\n    background-color: #F495D3;\n    border-radius: 40px;\n    text-decoration: none;\n    padding: 5px 17px;\n}\n\n.launching-date-wrap .top-button a:hover {\n    text-decoration: none !important;\n}\n\n.launching-date-wrap .description {\n    color: #FFF;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 33px;\n    padding: 32px 0px 43px;\n}\n\n.launching-date-wrap .bottom-btn a {\n    color: var(--Balck, #242424);\n    text-align: center;\n    font-size: 18.333px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n    background-color: #06EFC5;\n    text-decoration: none;\n    color: black !important;\n    padding: 18px 80px;\n}\n\n.launching-date-wrap .bottom-button a:hover {\n    text-decoration: none !important;\n}\n\n.launching-date-wrap a {\n    text-decoration: none !important\n}\n\n.launching-date-wrap .bottom-description {\n    color: #FFF;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 33px;\n    padding-top: 40px;\n}\n\n.launching-date-wrap .right-img img {\n    height: 500px;\n\n}\n\n\n@media (max-width: 1024px) {\n    .banner-wrap-competition .banner-right-img img{\n        width: 100%;\n    }\n}\n\n@media (max-width: 768px) {\n    .banner-wrap-competition {\n        padding: 30px;\n    }\n\n    .banner-wrap-competition .banner-right-img {\n        display: block;\n    }\n\n    .banner-wrap-competition .banner-content {\n        padding-left: 0px;\n    }\n\n    .banner-wrap-competition .banner-content .title {\n        font-size: 25px;\n        line-height: 39px;\n    }\n\n    .banner-wrap-competition .banner-content .sub-description {\n        font-size: 20px;\n        line-height: 34px;\n        text-align: left;\n    }\n\n    .banner-wrap-competition .banner-content .description {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 19px;\n        text-align: left;\n    }\n\n    .banner-wrap-competition .banner-right-img img {\n        width: 100%;\n    }\n\n    .banner-wrap-competition .banner-buttons {\n        flex-direction: column;\n        gap: 0.5rem;\n        display: none !important;\n    }\n\n    .launching-date-wrap {\n        padding: 50px 0px 70px;\n        text-align: center;\n    }\n\n    .launching-date-wrap .top-button a {\n        font-size: 15px;\n        line-height: 33px;\n    }\n\n    .launching-date-wrap .description {\n        font-size: 15px;\n        line-height: 29px;\n        padding-top: 20px;\n    }\n\n    .launching-date-wrap .bottom-description {\n        padding: 50px 0px 40px;\n        font-size: 15px;\n        line-height: 33px;\n    }\n\n    .launching-date-wrap .right-img img {\n        width: 100%;\n        height: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
